<template>
    <div :class="{ row: true, selected: selected }" 
        @mousedown="handleRowClick"
        @drop.capture="handleRowDrop"
        @dragenter.capture="handleRowDragEnterOrOver"
        @dragover.capture="handleRowDragEnterOrOver"
        :style="{ 'padding-left': indentWidth * row.indent + 'px' }">

        <div class="node-background">
            <div class="node" draggable @dragstart="handleDragStart" @dragend="handleDragEnd">
                <img class="node-icon" :src="'/icons/nodes/' + row.node.name + '.svg'">
                <div class="node-label">{{ row.name }}</div>
            </div>

            <div class="node-properties" v-if="hasPropertiesComponent">
                <component :is="propertiesComponent" :properties="row.node.properties"></component>
            </div>
        </div>
    </div>
</template>

<script>
import * as nodes from "@/nodes";

import Buffer from "./nodes/Buffer";
import Geometry from "./nodes/Geometry";
import Empty from "./nodes/Empty";
import Action from "./nodes/Action";
import Fragment from "./nodes/Fragment";
import Asset from "./nodes/Asset";
import AssetClass from "./nodes/AssetClass";
import AssetGroup from "./nodes/AssetGroup";
import SpeedRange from "./nodes/SpeedRange";
import LongerThan from "./nodes/LongerThan";
import TimeOfDay from "./nodes/TimeOfDay";
import TimeAndDateRange from "./nodes/TimeAndDateRange";
import Grouping from "./nodes/Grouping";

const componentsByName = {
    Buffer,
    Geometry,
    Action,
    Fragment,
    Asset,
    AssetClass,
    AssetGroup,
    SpeedRange,
    LongerThan,
    TimeOfDay,
    TimeAndDateRange,
    Grouping
};

import { unpackNodeDragSource } from "@/utilities.js";

export default {
    props: {
        row: { type: Object, required: true },
        indentWidth: { type: Number, required: true },
        selected: { type: Boolean, default: true }
    },
    computed: {
        hasPropertiesComponent() {
            return componentsByName[this.row.node.name] !== undefined;
        },
        propertiesComponent() {
            let component = componentsByName[this.row.node.name];

            if (component === undefined) component = Empty;

            return component;
        }
    },
    methods: {
        _getRowEventDetails(e) {
            let bounds = this.$el.getBoundingClientRect();
            let middleY = (bounds.top + bounds.bottom) / 2;

            let [sourceKind, sourceValue, sourceOptions] = unpackNodeDragSource(e);

            let details = {
                row: this.row,
                rowOffset: e.clientY < middleY ? 0 : 1,
                columnIndent: Math.max(0, Math.floor((e.clientX - bounds.x) / this.indentWidth)),
                bounds: bounds,
                sourceKind,
                sourceValue,
                sourceOptions
            };

            return details;
        },
        handleRowDrop(e) {
            e.preventDefault();

            this.$emit('dragDrop', this._getRowEventDetails(e));
        },
        handleRowDragEnterOrOver(e) {
            e.preventDefault();
            e.stopPropagation();

            this.$emit('dragOver', this._getRowEventDetails(e));
        },
        handleDragStart(e) {
            e.dataTransfer.setData("node-row", this.row.key.toString());

            this.$emit('row-dragging-started', this.row);
        },
        handleDragEnd(e) {
        },
        handleRowClick() {
            this.$emit('click');
        }
    }
}
</script>

<style lang="less" scoped>
.row
{
    user-select: none;
    padding-top: 3px;
    padding-bottom: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.node
{
    display: inline-flex;
    font-size: 12px;
    background-color: #ddd;
    padding: 4px 4px;
    border-radius: 3px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    flex-direction: row;
    align-items: center;
}
.node-background
{
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid #aaa;
    border-radius: 4px;
    background-color: #eee;
}
.node-properties
{
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    padding: 0 8px;
}
.selected .node-background
{
    border-color: darken(#66c8ff, 30%);
}
.selected .node
{
    background-color: mix(#66c8ff, #eeeeee, 80%);
}
.node-icon
{
    width: 23px;
}
.node-label
{
    padding: 0 6px;
}
.delete
{
    padding: 0 4px;
}
</style>
